import React from "react";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
import onboardingimg1 from "../../../../assets/onboarding-img1.svg";
import onboardingimg2 from "../../../../assets/onboarding-img2.svg";
import Title from "../Title";
import { Link } from "react-router-dom";
export const OnBoardingScreen = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);
  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  return (
    <div className={"formcontainer" + " " + style.container}>
      <Link to="/"><Title /></Link>
      <div className={"custom-wrapper"}>
        <div className="topHeadarea">
          <div className="small-head">Create a survey</div>
          <div className="blue-head">How would you like to get started?</div>
        </div>
        <div className="myflex-container">

          <Link to="/TeamProcessDone">
        
          <div className="myflex-item-left">
            <div className="custom-card">
              <div className="onboard-image">
                <img className="imgoxauto" src={onboardingimg1} alt="Start from template" />
              </div>
              <div className="onboard-description">
                <h5 className="texth5 onboard-name">Start from template</h5>
                <p className=" onboard-text">Choose from our library of ready-to-use survey templates.</p>
              </div>
            </div>

          </div>
          </Link>
          <Link to="/TeamProcessDone">
            <div className="myflex-item-right">
              <div className="custom-card">
                <div className="onboard-image">
                  <img className="imgoxauto" src={onboardingimg2} alt="Start from Scratch" />
                </div>
                <div className="onboard-description">
                  <h5 className="texth5 onboard-name">Start from Scratch</h5>
                  <p className=" onboard-text">Build your survey from scratch.</p>
                </div>
              </div>

            </div>
          </Link>

        </div>


      </div >

    </div >
  );
};

export default OnBoardingScreen;
